import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,Typography } from "@mui/material";
import styles from "./style";
import CustomPagination from "../../../../components/CustomPagination";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import{ ProfitData }from "../../../../constants/data"
// import { useAlert } from "../../../../context/AlertContext";


const ProfitLossList = () => {

  
  const [page, setPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const {showAlert} =useAlert();
  
  return (
    <>

           
      <TableContainer  sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>Type</TableCell>
              <TableCell sx={styles.tableHead}>Total</TableCell>
              <TableCell sx={styles.tableHead}>Amount</TableCell>
              <TableCell sx={styles.tableHead}>VAR%</TableCell>
              <TableCell sx={styles.tableHead}>Overall Share(%)</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {ProfitData?.length === 0 ? ( 
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              ProfitData?.map((item, index) => (
                <TableRow key={index} sx={{verticalAlign:"baseline"}}>
                  <TableCell sx={styles.tabledata}>{item?.type} </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.total}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.amount}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.var}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.overall}</TableCell>

                </TableRow>
              ))
            )}
          </TableBody>

        </Table>
        {ProfitData &&
       <CustomPagination
         //  pageCount={totalCount}         
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalItems={ProfitData.length}
       />} 

      </TableContainer>


    </>
  );
};
export default ProfitLossList;
